<mat-toolbar color="primary" style="background-color: #04121D;">
  <mat-toolbar-row>
    <!-- <button mat-icon-button (click)="sidenav.toggle()">
      <mat-icon>menu</mat-icon>
    </button> -->
    <a mat-button style="font-family:'Courier New', Courier, monospace; font-size: 24px; font-weight: bold;" [routerLink]="'/homePage'" [disabled]="!auth.isAuthenticated()"> NELNET </a>
    &nbsp;&nbsp;
    <div *ngIf="auth.isAuthenticated()">
      <button mat-button style="font-size: 18px; padding-right: 10px; padding-left: 10px;" color="white" (click)="showSideNav = !showSideNav">
        <span *ngIf="showSideNav">Hide</span>
        <span *ngIf="!showSideNav">Show</span>
        Tables
      </button>
      <button mat-button style="font-size: 18px; padding-right: 10px; padding-left: 10px;" *ngFor="let item of navigation"
        [routerLink]="[item.link]" routerLinkActive="mat-accent" color="white" [disabled]=item.disabled (click)="showSideNav = false">
        {{item.label}}
      </button>
    </div>

    <span class="spacer"></span>

    <button *ngIf="auth.isAuthenticated() && canImportData" mat-raised-button style="font-size: 18px;" color="accent" (click)="import()">Import Data</button>
    <button *ngIf="auth.isAuthenticated() && canCreateTables" mat-raised-button style="font-size: 18px;" color="accent" (click)="newTable()">New Table</button>

    <button *ngIf="!auth.isAuthenticated()" mat-raised-button style="font-size: 18px" color="accent" (click)="login()">Login</button>
    <button *ngIf="auth.isAuthenticated()" mat-raised-button style="font-size: 18px" color="warn" (click)="auth.logout()">Logout</button>
  </mat-toolbar-row>
</mat-toolbar>

<mat-sidenav-container *ngIf="auth.isAuthenticated()" class="sidenav-container">
  <mat-sidenav #sidenav mode="side" [opened]="showSideNav" class="sidenav">
    <mat-nav-list>
      <a mat-list-item *ngFor="let table of tables;" [routerLink]="['/tableDetail', table.name]"> {{table.name}} </a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <div style="height: calc(100vh - 64px);">
      <router-outlet></router-outlet>
      <span *ngIf="userNotFoundError.length > 0">{{userNotFoundError}}</span>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
